import axios from "../../config/axiosConfig";
import {
  MACHINE_WISE_BEAM_STOCK_REPORT_REQUEST,
  MACHINE_WISE_BEAM_STOCK_REPORT_SUCCESS,
  MACHINE_WISE_BEAM_STOCK_REPORT_FAILURE,
  MACHINE_WISE_BEAM_STOCK_FILTER_REPORT_REQUEST,
  MACHINE_WISE_BEAM_STOCK_FILTER_REPORT_SUCCESS,
  MACHINE_WISE_BEAM_STOCK_FILTER_REPORT_FAILURE,
} from "../types";

export const getMachineWiseBeamStockReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: MACHINE_WISE_BEAM_STOCK_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        commonMaster: !!auth?.company?.Common_Master
      };

      const requestParams = { ...defaultParams, ...params };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/stock-report/machineWiseBeamStockReport?${queryString}`;

      console.log('<<Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: MACHINE_WISE_BEAM_STOCK_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: MACHINE_WISE_BEAM_STOCK_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: MACHINE_WISE_BEAM_STOCK_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getMachineWiseBeamStockFilterDetail = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: MACHINE_WISE_BEAM_STOCK_FILTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        commanMaster: auth?.company?.Common_Master,
      };

      // Merge default params with provided params
      const requestParams = { ...defaultParams };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/stock-report/machineWiseBeamStockFilterOptions?${queryString}`;

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: MACHINE_WISE_BEAM_STOCK_FILTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: MACHINE_WISE_BEAM_STOCK_FILTER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: MACHINE_WISE_BEAM_STOCK_FILTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearMachineWiseBeamStockReport = () => {
  return async (dispatch) => {
    dispatch({ type: MACHINE_WISE_BEAM_STOCK_REPORT_SUCCESS, payload: {} });
  }
}
